export type PublishedCmsPages = Record<string, boolean | string>;

export const excludeCmsPageGroups = (
  publishedPages: PublishedCmsPages,
  disabledGroups: readonly string[],
): PublishedCmsPages => {

  if (!disabledGroups.length) {

    return publishedPages;

  }

  const disabledGroupsSet = new Set(disabledGroups);

  return Object.fromEntries(
    Object.entries(publishedPages).filter(([, value]) =>
      typeof value !== 'string' || !disabledGroupsSet.has(value)),
  );

};
